var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Car",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4779",
    "data-name": "Ellipse 4779",
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#f1f7f7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car_4_",
    "data-name": "car (4)",
    d: "M51.024,105.968a11.3,11.3,0,0,0-2.381-1.3c.376-.194.633-.234.633-1.037,0-.876,0-1.168-.588-1.168H46.706l-.025-.054c-1.279-2.793-1.451-3.5-3.358-4.45-2.559-1.272-7.356-1.337-9.237-1.337s-6.678.064-9.234,1.337c-1.91.949-1.862,1.437-3.358,4.45a.279.279,0,0,1-.029.054H19.481c-.58,0-.584.292-.584,1.168,0,.8.257.843.633,1.037a20.811,20.811,0,0,0-2.381,1.3c-.292.292-.584,2.336-.584,5.84s.292,7.008.292,7.008h.872c0,1.022.15,1.168.588,1.168h5.84c.438,0,.584-.146.584-1.168H43.431c0,1.022.146,1.168.584,1.168H50c.292,0,.438-.219.438-1.168h.876s.292-3.577.292-7.008-.365-5.475-.584-5.84Zm-26.482,3.281a37.731,37.731,0,0,1-4,.223c-1.491,0-1.542.1-1.647-.835a5.268,5.268,0,0,1,.037-1.278l.046-.223h.219a10.068,10.068,0,0,1,3.252.495,7.154,7.154,0,0,1,2.2,1.1,1.052,1.052,0,0,1,.391.45ZM42.586,114.5l-.323.807H25.91s.028-.045-.365-.816c-.292-.571.073-.936.65-1.143a24.291,24.291,0,0,1,7.891-1.545,20.672,20.672,0,0,1,7.921,1.545c.4.207.9.353.578,1.156Zm-18.762-9.967a7.027,7.027,0,0,1-.708.005c.191-.339.3-.716.483-1.11.584-1.241,1.252-2.646,2.441-3.238,1.719-.856,5.28-1.241,8.047-1.241s6.329.383,8.047,1.241c1.189.592,1.854,2,2.441,3.238.188.4.292.778.488,1.119-.146.008-.314,0-.715-.014Zm25.385,4.1c-.156.911-.01.838-1.574.838a37.732,37.732,0,0,1-4-.223.313.313,0,0,1-.1-.518,6.851,6.851,0,0,1,2.2-1.1,9.464,9.464,0,0,1,3.292-.488.235.235,0,0,1,.226.219,5.119,5.119,0,0,1-.036,1.275Z",
    transform: "translate(2.913 -71.304)",
    fill: "#66939f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.6c21e16203241ee546ab018b752ac064.svg";
export { ForwardRef as ReactComponent };